import { render, staticRenderFns } from "./CardTask.vue?vue&type=template&id=dd9d0562&scoped=true"
import script from "./CardTask.vue?vue&type=script&lang=js"
export * from "./CardTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d0562",
  null
  
)

export default component.exports